import React from 'react';
import './CustomModal.css';
import { Button, Modal } from 'react-bootstrap';

function CustomConfModal({ show, message, header, handleOK, handleClose }) {

  /**
   * モーダルクローズ（OK）
   */
  function handleModalOK() {
    show = false;
    handleOK();
  }

  /**
   * モーダルクローズ
   */
  function handleModalClose() {
    show = false;
    handleClose();
  }

  return (
    <>
      <Modal show={show} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea
              className="modal_text_area"
              cols="100"
              rows="8"
              value={message}
              readOnly="readOnly"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button block className="btn-nomal" onClick={handleModalOK}>
            はい
          </Button>
          <Button className="btn-nomal" onClick={handleModalClose}>
            いいえ
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CustomConfModal;